import type { BeforeSendHook, LogEvent } from '@grafana/faro-web-sdk';
import { TransportItemType } from '@grafana/faro-web-sdk';

const addLogContext: BeforeSendHook = (event) => {
  if (event.type === TransportItemType.LOG) {
    // event.payload.context may be undefined, so we need to merge the potential object
    (event.payload as LogEvent).context = {
      ...(event.payload as LogEvent).context,
      source: 'client-logger',
    };
  }
  return event;
};

export { addLogContext };
